import {
  LOGIN_REQUEST, LOGIN_SUCCESS, AUTH_FAILURE, LOGOUT_SUCCESS, RESET_REQUEST, RESET_SUCCESS,
  PASSWORD_RESET_EMAIL_REQUEST, PASSWORD_RESET_EMAIL_SUCCESS, AUTH_INIT_SUCCESS, AUTH_INIT_ERROR,
  REGISTER_REQUEST, REGISTER_SUCCESS, AUTH_IDENTITY_ROLES_SUCCESS
} from '../actions/auth';

export default function auth(state = {
  isFetching: false,
  errorMessage: '',
  currentUser: null,
  merchant: null,
  loadingInit: true,
  identityRoles: [],
  isRebelityAdmin: false,
  identityRolesLoaded: false,
}, {type, payload}) {
  switch (type) {
      case LOGIN_REQUEST:
      case RESET_REQUEST:
      case PASSWORD_RESET_EMAIL_REQUEST:
      case REGISTER_REQUEST:
          return Object.assign({}, state, {
              isFetching: true,
              errorMessage: '',
          });
      case LOGIN_SUCCESS:
      case RESET_SUCCESS:
      case PASSWORD_RESET_EMAIL_SUCCESS:
      case REGISTER_SUCCESS:
          return Object.assign({}, state, {
              isFetching: false,
              errorMessage: '',
              currentUser: payload?.user || state.currentUser,
          });
      case AUTH_FAILURE:
          return Object.assign({}, state, {
              isFetching: false,
              errorMessage: payload,
          });
      case AUTH_INIT_SUCCESS:
          return Object.assign({}, state, {
              currentUser: payload.currentUser || null,
              merchant: payload.merchant || null,
              loadingInit: false,
              identityRoles: payload.identityRoles || state.identityRoles,
              isRebelityAdmin: typeof payload.isRebelityAdmin === 'boolean'
                  ? payload.isRebelityAdmin
                  : state.isRebelityAdmin,
              identityRolesLoaded: typeof payload.identityRolesLoaded === 'boolean'
                  ? payload.identityRolesLoaded
                  : state.identityRolesLoaded,
          });
      case AUTH_IDENTITY_ROLES_SUCCESS:
          return Object.assign({}, state, {
              identityRoles: payload.identityRoles || [],
              isRebelityAdmin: !!payload.isRebelityAdmin,
              identityRolesLoaded: payload.identityRolesLoaded !== false,
          });
      case AUTH_INIT_ERROR:
          return Object.assign({}, state, {
              currentUser: null,
              merchant: null,
              loadingInit: false,
              identityRoles: [],
              isRebelityAdmin: false,
              identityRolesLoaded: true,
          });
      case LOGOUT_SUCCESS:
          return Object.assign({}, state, {
              isFetching: false,
              errorMessage: '',
              currentUser: null,
              merchant: null,
              identityRoles: [],
              isRebelityAdmin: false,
              identityRolesLoaded: true,
          });
      default:
          return state;
  }
}
